<template>
  <div class="col-12">
    <div class="card card--profile-tasks">
      <div
        v-b-toggle="`collapseOSHNotifications`"
        class="card-header"
      >
        <h3 class="float-start"> OSH notifications <span
          v-if="!loading"
          class="badge bg-light-info"
        >{{ items.length }}</span>
        </h3>
        <div class="heading-elements heading-elements-custom">
          <div class="btn-group dropdown-icon-wrapper d-none d-sm-block disp-in">
            <b-dropdown
              class="btn btn-secondary btn-sm"
              toggle-class="p-0"
              @click="$event.stopPropagation()"
            >
              <template #button-content>
                Multiple actions
              </template>
              <b-dropdown-item @click="archive">
                <i
                  class="me-50"
                  data-feather="archive"
                /> Archive
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <ul class="list-inline mb-0 disp-in ms-2">
            <li>
              <a data-action="collapse"><svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-chevron-down"
              ><polyline points="6 9 12 15 18 9" /></svg></a>
            </li>
          </ul>
        </div>
      </div>
      <b-collapse
        :id="`collapseOSHNotifications`"
        :visible="fields.find(e => e.name == 'OSH notifications').visibility"
      >
        <div class="card-body">
          <div
            v-if="loading"
            class="loading position-relative"
          >
            <div class="effect-1 effects" />
            <div class="effect-2 effects" />
            <div class="effect-3 effects" />
          </div>
          <div
            v-else
            class="table-responsive"
          >
            <table class="table table-striped table-hover">
              <thead>
                <tr>
                  <th
                    class="cursor-pointer"
                  >
                    <input
                      v-model="clicked"
                      type="checkbox"
                      @click="selectAll($event)"
                    >
                  </th>
                  <th>Type</th>
                  <th>User</th>
                  <th>Host</th>
                  <th>Date entry</th>
                  <th>Section</th>
                  <th>Subsection</th>
                  <th>Title</th>
                  <th class="text-end">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in items"
                  :key="index"
                >
                  <td>
                    <input
                      :checked="
                        clicked
                      "
                      type="checkbox"
                      @click="select($event.target.checked, item)"
                    >
                  </td>
                  <td>
                    <span
                      v-if="item.type === 'panic_button'"
                      class="badge bg-light-danger"
                    >OSH Alert</span>
                    <span
                      v-else
                      class="badge bg-light-info"
                    >Document</span>
                  </td>
                  <td>{{ item.user ? item.user.full_name : '-' }}</td>
                  <td>{{ item.host ? item.host.code : '-' }}</td>
                  <td>{{ item.created_at }}</td>
                  <td>{{ item.section ? item.section.name : (item.type === 'panic_button' ? 'OSH Alert' : '-') }}</td>
                  <td>{{ item.subsection && item.subsection[0] ? item.subsection[0].name : '-' }}</td>
                  <td>
                    {{ item.title }}
                    <small
                      v-if="item.reason"
                      class="d-block text-muted"
                    >{{ item.reason }}</small>
                  </td>
                  <td class="text-end">
                    <span
                      class="dis-ib"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Edit area and group"
                    >
                      <a
                        :href="item.doc_url"
                        target="_blank"
                      >
                        <i data-feather="file" />
                      </a>
                    </span>
                    <span
                      v-if="item.response_doc"
                      class="dis-ib ms-1"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Edit area and group"
                    >
                      <a
                        :href="item.response_doc"
                        target="_blank"
                      >
                        <i data-feather="eye" />
                      </a>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { BDropdown, BDropdownItem, BCollapse } from 'bootstrap-vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    BDropdown,
    BDropdownItem,
    BCollapse,
  },
  data() {
    return {
      userId: this.$route.params.id,
      loading: false,
      selectedItems: [],
      clicked: false,
    }
  },
  computed: {
    ...mapGetters({
      items: 'cae/alerts',
      fields: 'modals/tableSettingsFields',
      loggedUser: 'auth/admin',
    }),
  },
  async mounted() {
    await this.$store.dispatch('cae/fetchAlertsActive')
    feather.replace({
      width: 14,
      height: 14,
    })
  },
  methods: {
    async archive(event) {
      this.loading = true
      event.stopPropagation()
      this.selectedItems.forEach(async e => {
        await this.$store.dispatch('cae/archiveAlert', e.id)
      })

      setTimeout(async () => {
        await this.$store.dispatch('cae/fetchAlertsActive')
        this.loading = false
        feather.replace({
          width: 14,
          height: 14,
        })
      }, 300)
    },
    selectAll(event) {
      if (event.target.checked) {
        this.selectedItems = this.items
      } else {
        this.selectedItems = []
      }
    },
    select(click, item) {
      if (click) {
        this.selectedItems.push(item)
      } else {
        this.selectedItems.splice(this.selectedItems.findIndex(x => x.id === item.id), 1)
      }
    },
  },
}
</script>
